// extracted by mini-css-extract-plugin
module.exports = {"main":"PremiumPillIcon_main__m_pXT"};